import React from 'react'
import ReactDOM from 'react-dom'
import { debounce, forEach } from 'lodash'
import { __, sprintf } from 'StylistParent/i18n'
import Dashicon from 'Components/dashicon'

/* Import CSS */
import './index.scss'

class ResponsiveControls extends React.Component {
	constructor( props ) {
		super( props )

		/* this.state = {
			isEnabled: false,
			isOver: false,
		} */

		// this.handleHoverOn = this.handleHoverOn.bind(this);
	}

	isEnabled = () => {
		 
		// return this.state.isEnabled
	}

	togglePopup = () => {
		/* this.setState( {
			isOver: ! this.state.isOver,
		} ) */
	}

	componentDidMount = () => {
	}

	componentWillMount = () => {
		if ( ! this.props.currentMediaType ) {
			// Getting all media queries as an array.
			const queries = window.stlst_legacy.getAllMediaQueries()

			let countMinQueries = 0
			let countMaxQueries = 0
			let newMediaType = ''

			// Iterate through properties of the object
			forEach( queries, function( mediaQuery, key, collection ) {
				if ( mediaQuery.includes( 'min-width' ) ) {
					countMinQueries += 1
				} else if ( mediaQuery.includes( 'max-width' ) ) {
					countMaxQueries += 1
				}
			} )

			// Update .media-control attribute 'data-code'
			// accoring to biggest number media queries.
			if ( countMinQueries > countMaxQueries ) {
				newMediaType = 'min-width'
			} else {
				newMediaType = 'max-width'
			}

			// Change in app state.
			this.props.onCurrentMediaTypeChange( newMediaType )
		}
	}

	onMediaTypeChange = ( event ) => {
		 
		// Pass new value to the parrent App component.
		this.props.onCurrentMediaTypeChange( event.target.value )
	}

	render() {
		// const { type, name } = this.props;

		const media = '1024px'
		const mediaTypeOptions = [
			{
				label: __( 'below' ),
				value: 'max-width',
			},
			{
				label: __( 'above' ),
				value: 'min-width',
			},
		]

		return (
			<div className="stlst--responsive-controls">
				<div id="responsive-size-text">
					{/* @todo: change it to dashicon and link to our new documentation */}
					{/* <a href="http://stylistwp.com/documentation/#responsive-tool" target="_blank" class="support-icon" data-toggle='tooltip' data-placement='right' title='Click here to take a look at Responsive Tool docs.'>?</a> */}
					<span>Affects <span className="device-size"></span>px and </span>
					<select id="stlst-media-type"
						onChange={ this.onMediaTypeChange }
						value={ this.props.currentMediaType } >
						{ mediaTypeOptions.map( ( option, index ) => (
							<option
								value={option.value}
								key={index}
							>{option.label}</option>
						) )}
					</select>
					<span> screen sizes. </span>
					<span className="device-name"></span>
				</div>

				<div className="breakpoint-bar"></div>
				<div className="metric"></div>
			</div>
		)
	}
}

export default ResponsiveControls;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/responsive-controls/index.jsx